import { formAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  formAnatomy.keys,
);

const FormTheme = defineMultiStyleConfig({
  baseStyle: {
    container: {
      marginBottom: "16px",
      "&[data-disabled]:not([aria-readonly])": {
        opacity: 0.5,
      },
    },
    helperText: {
      marginTop: "2px",
      fontSize: "10px",
      // Same as FormErrorMessage+FormErrorIcon,
      // avoid layout changes when showing/hiding errors
      minHeight: "15px",
      lineHeight: "15px",
    },
  },
  variants: {
    simple: {
      container: {
        marginBottom: 0,
      },
    },
    "simple-table": {
      container: {
        marginBottom: 0,
        width: "100%",
        height: "100%",
        ".chakra-input__group": {
          height: "100%",
        },
        ".chakra-input__left-element, .chakra-input__right-element": {
          position: "unset",
          width: "unset",
          height: "100%",
          "&.chakra-input__left-element": {
            ml: "8px",
            mr: "-8px",
          },
          "&.chakra-input__right-element": {
            ml: "-8px",
            mr: "8px",
            svg: {
              width: "16px",
              height: "16px",
            },
            ".mb-input-clear": {
              height: "37px",
              right: 0,
              borderRadius: 0,
              mr: "-8px",
              p: 0,
              svg: {
                width: "24px",
                height: "24px",
              },
            },
          },
        },
      },
    },
  },
});

export default FormTheme;
